import { render } from "./questionBodyComponent.vue?vue&type=template&id=5b133422&scoped=true"
import script from "./questionBodyComponent.vue?vue&type=script&lang=js"
export * from "./questionBodyComponent.vue?vue&type=script&lang=js"

import "./questionBodyComponent.vue?vue&type=style&index=0&id=5b133422&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b133422"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionBodyComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b133422"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b133422', __exports__)) {
    api.reload('5b133422', __exports__)
  }
  
  module.hot.accept("./questionBodyComponent.vue?vue&type=template&id=5b133422&scoped=true", () => {
    api.rerender('5b133422', render)
  })

}


export default __exports__